import { render, staticRenderFns } from "./usage_details.vue?vue&type=template&id=973aeaa0&vue3"
import script from "./usage_details.vue?vue&type=script&lang=js&vue3"
export * from "./usage_details.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports